export interface ComicChapter {
  id: string;
  title: string;
  updateTime: string;
}

export interface Comic {
  id: string;
  title: string;
  category: string;
  status: string;
  tagline: string;
  author: string;
  description: string;
  cover: string;
  views: number;
  likes: number;
  collects: number;
  rating: number;
  latestChapter: string;
  isHot: boolean;
  isNew: boolean;
  chapters: ComicChapter[];
}

export interface ComicCategory {
  key: string;
  name: string;
  desc: string;
  icon: string;
}

export const categories: ComicCategory[] = [
  {
    key: "ycmr",
    name: "养猫日常",
    desc: "从接猫回家到猫咪长大的每一帧，记录铲屎官的欢喜日常。",
    icon: "ri-home-smile-line",
  },
  {
    key: "shenghuo",
    name: "生活日常",
    desc: "人与猫交织的烟火日子，温情与搞笑并存的生活片段。",
    icon: "ri-cup-line",
  },
  {
    key: "qushi",
    name: "日常趣事",
    desc: "猫咪那些让人哭笑不得的迷惑行为，笑点满满。",
    icon: "ri-emotion-happy-line",
  },
  {
    key: "chengzhang",
    name: "成长萌新",
    desc: "新手铲屎官进阶指南，从零开始学会照顾每一只喵。",
    icon: "ri-plant-line",
  },
];

export const comics: Comic[] = [
  {
    id: "orange-and-me",
    title: "橘猫和我的一天",
    category: "养猫日常",
    status: "连载中",
    tagline: "一只橘猫如何承包了我的所有快乐",
    author: "鱼丸小铺",
    description:
      "因为一时冲动，我收养了一只名叫「年糕」的橘猫。从那以后，我的生活彻底变了样：每天早上被它踩醒、吃饭被它盯着、工作被它霸占键盘。这本漫画用温柔又搞笑的笔触，记录我和年糕互相陪伴的每一个平凡日子，橘猫的饭量之谜、赖床绝活、以及它藏起来的那些小秘密。",
    cover:
      "https://readdy.ai/api/search-image?query=A%20cute%20chubby%20orange%20tabby%20cat%20sitting%20beside%20a%20laptop%20on%20a%20cozy%20desk%2C%20warm%20cream%20and%20peach%20background%2C%20soft%20flat%20illustration%20style%2C%20gentle%20natural%20light%2C%20heartwarming%20daily%20comic%20cover%20art&width=800&height=1000&seq=cover-orange-01&orientation=portrait",
    views: 128400,
    likes: 8560,
    collects: 4230,
    rating: 4.8,
    latestChapter: "第 128 话：开饭警报",
    isHot: true,
    isNew: true,
    chapters: [
      { id: "c1", title: "第 128 话：开饭警报", updateTime: "今天 10:20" },
      { id: "c2", title: "第 127 话：键盘争夺战", updateTime: "昨天 18:30" },
      { id: "c3", title: "第 126 话：纸箱王国", updateTime: "3 天前" },
      { id: "c4", title: "第 125 话：清晨踩醒术", updateTime: "5 天前" },
      { id: "c5", title: "第 124 话：窗外的小鸟", updateTime: "一周前" },
    ],
  },
  {
    id: "fluffy-troubles",
    title: "掉毛星人日常",
    category: "日常趣事",
    status: "连载中",
    tagline: "家里全是毛，但全是爱",
    author: "毛球工坊",
    description:
      "养了一只长毛猫之后，我的黑色衣服基本告别了。从满屋飞毛到粘毛器进货计划，从换毛季到梳毛大作战，这本漫画把铲屎官最真实的狼狈日常画成了段子。原来，「毛」也可以是一种浪漫，只是它无处不在。",
    cover:
      "https://readdy.ai/api/search-image?query=A%20fluffy%20white%20long-haired%20cat%20covered%20in%20floating%20fur%20on%20a%20soft%20couch%2C%20warm%20cream%20and%20light%20coral%20background%2C%20cute%20flat%20illustration%20comic%20cover%2C%20playful%20and%20cozy%20atmosphere&width=800&height=1000&seq=cover-fluffy-02&orientation=portrait",
    views: 96800,
    likes: 6410,
    collects: 2980,
    rating: 4.7,
    latestChapter: "第 96 话：梳毛大作战",
    isHot: true,
    isNew: false,
    chapters: [
      { id: "c1", title: "第 96 话：梳毛大作战", updateTime: "今天 09:05" },
      { id: "c2", title: "第 95 话：满屋飞毛", updateTime: "昨天 21:10" },
      { id: "c3", title: "第 94 话：粘毛器进货", updateTime: "4 天前" },
      { id: "c4", title: "第 93 话：换毛季", updateTime: "6 天前" },
    ],
  },
  {
    id: "night-stalker",
    title: "夜行者小灰",
    category: "生活日常",
    status: "连载中",
    tagline: "午夜三点的猫咪蹦迪现场",
    author: "布丁漫记",
    description:
      "小灰是一只黑白奶牛猫，白天它是高冷小王子，一到深夜就化身跑酷选手。凌晨三点在走廊里狂奔、在天花板下跳来跳去、把桌上的杯子当足球。这本漫画记录了我与「夜行者」斗智斗勇的爆笑日常，也藏着对这个小捣蛋鬼满满的爱。",
    cover:
      "https://readdy.ai/api/search-image?query=A%20black%20and%20white%20tuxedo%20cat%20mid-jump%20in%20a%20moonlit%20cozy%20living%20room%20at%20night%2C%20warm%20indoor%20lighting%2C%20soft%20cream%20and%20amber%20background%2C%20cute%20flat%20comic%20illustration%20cover%2C%20playful%20dynamic%20mood&width=800&height=1000&seq=cover-night-03&orientation=portrait",
    views: 81200,
    likes: 5230,
    collects: 2540,
    rating: 4.6,
    latestChapter: "第 84 话：午夜跑酷",
    isHot: false,
    isNew: true,
    chapters: [
      { id: "c1", title: "第 84 话：午夜跑酷", updateTime: "今天 12:00" },
      { id: "c2", title: "第 83 话：天花板冒险", updateTime: "昨天 20:00" },
      { id: "c3", title: "第 82 话：杯子的宿命", updateTime: "3 天前" },
    ],
  },
  {
    id: "newbie-catsitter",
    title: "新手铲屎官指南",
    category: "成长萌新",
    status: "已完结",
    tagline: "从养猫小白到合格铲屎官",
    author: "喵学堂",
    description:
      "刚把猫咪接回家时，我连猫砂都不会选。这本漫画是给所有新手铲屎官的入门手册：怎么接猫回家、怎么布置猫窝、怎么处理猫咪应激、怎么判断它是否健康。用漫画把专业养猫知识讲得轻松好懂，让每一只喵都能被温柔以待。",
    cover:
      "https://readdy.ai/api/search-image?query=A%20cute%20kitten%20peeking%20out%20of%20a%20cozy%20cat%20bed%20with%20care%20supplies%2C%20warm%20cream%20and%20soft%20coral%20background%2C%20friendly%20flat%20illustration%20comic%20cover%2C%20educational%20heartwarming%20mood&width=800&height=1000&seq=cover-newbie-04&orientation=portrait",
    views: 67300,
    likes: 3980,
    collects: 5010,
    rating: 4.9,
    latestChapter: "全 60 话",
    isHot: false,
    isNew: false,
    chapters: [
      { id: "c1", title: "第 60 话：毕业啦", updateTime: "1 个月前" },
      { id: "c2", title: "第 59 话：健康体检", updateTime: "1 个月前" },
      { id: "c3", title: "第 58 话：应急处理", updateTime: "1 个月前" },
      { id: "c4", title: "第 57 话：饮食营养", updateTime: "1 个月前" },
    ],
  },
  {
    id: "three-cats-drama",
    title: "三猫家庭大作战",
    category: "养猫日常",
    status: "连载中",
    tagline: "三只猫，一台戏，天天热闹",
    author: "多猫档案",
    description:
      "家里的猫从一只变成三只之后，每天的戏码翻了三倍：抢猫爬架、争夺窗台、轮流争宠、组团拆家。这本漫画记录了三猫家庭的欢乐与混乱，也讲述了不同性格的猫咪如何从陌生到成为一家人。热闹背后，是铲屎官操不完的心和满满的爱。",
    cover:
      "https://readdy.ai/api/search-image?query=Three%20cats%20of%20different%20colors%20playing%20together%20on%20a%20sunny%20window%20sill%2C%20warm%20cream%20and%20peach%20background%2C%20cute%20flat%20comic%20illustration%20cover%2C%20lively%20and%20cozy%20home%20atmosphere&width=800&height=1000&seq=cover-three-05&orientation=portrait",
    views: 59400,
    likes: 4120,
    collects: 2070,
    rating: 4.7,
    latestChapter: "第 72 话：窗台争夺",
    isHot: true,
    isNew: false,
    chapters: [
      { id: "c1", title: "第 72 话：窗台争夺", updateTime: "今天 08:40" },
      { id: "c2", title: "第 71 话：组团拆家", updateTime: "昨天 19:00" },
      { id: "c3", title: "第 70 话：轮番争宠", updateTime: "5 天前" },
    ],
  },
  {
    id: "fat-cat-diet",
    title: "胖猫减肥计划",
    category: "日常趣事",
    status: "连载中",
    tagline: "铲屎官和胖猫的斗争史",
    author: "减脂喵生",
    description:
      "我家猫十斤半，兽医说该减减了。从严格控粮到逗猫棒特训，从智能猫碗到各种减肥妙招，这场「胖猫减肥计划」笑料百出。可是，看着它委屈的小眼神，我又心软了。这本漫画，记录了每一个铲屎官都懂的「嘴上说减肥，身体很诚实」的日常。",
    cover:
      "https://readdy.ai/api/search-image?query=A%20round%20plump%20cat%20looking%20upset%20at%20a%20measuring%20scale%20in%20a%20cozy%20kitchen%2C%20warm%20cream%20and%20light%20orange%20background%2C%20cute%20flat%20comic%20illustration%20cover%2C%20funny%20and%20heartwarming%20mood&width=800&height=1000&seq=cover-fat-06&orientation=portrait",
    views: 88700,
    likes: 6100,
    collects: 3320,
    rating: 4.8,
    latestChapter: "第 108 话：称重日",
    isHot: false,
    isNew: true,
    chapters: [
      { id: "c1", title: "第 108 话：称重日", updateTime: "今天 11:30" },
      { id: "c2", title: "第 107 话：逗猫棒特训", updateTime: "昨天 17:00" },
      { id: "c3", title: "第 106 话：智能猫碗", updateTime: "3 天前" },
    ],
  },
  {
    id: "window-bird",
    title: "窗边的小鸟",
    category: "生活日常",
    status: "已完结",
    tagline: "一只猫对窗外的执念",
    author: "晴天绘本",
    description:
      "每天清晨，我家猫都会准时蹲在窗边，一动不动地盯着窗外的小鸟。那是它一天中最专注的时刻。这本治愈系短篇漫画，用温柔的笔触画下猫咪与窗外小鸟之间无声的对望，安静、美好，又带着一点淡淡的诗意。",
    cover:
      "https://readdy.ai/api/search-image?query=A%20cat%20silhouette%20gazing%20out%20a%20window%20at%20a%20small%20bird%20in%20soft%20morning%20light%2C%20warm%20cream%20and%20amber%20background%2C%20gentle%20flat%20comic%20illustration%20cover%2C%20quiet%20and%20poetic%20mood&width=800&height=1000&seq=cover-window-07&orientation=portrait",
    views: 45200,
    likes: 3320,
    collects: 1890,
    rating: 4.6,
    latestChapter: "全 30 话",
    isHot: false,
    isNew: false,
    chapters: [
      { id: "c1", title: "第 30 话：黄昏的告别", updateTime: "2 个月前" },
      { id: "c2", title: "第 29 话：午后的凝视", updateTime: "2 个月前" },
    ],
  },
  {
    id: "grey-boss",
    title: "老板猫大人",
    category: "日常趣事",
    status: "连载中",
    tagline: "我家猫才是真正的老板",
    author: "打工人与猫",
    description:
      "上班是打工，回家是「给猫打工」。我家那只灰色英短，每天用眼神指挥我端饭、开窗、让位。从办公桌C位到沙发霸主，从催饭到查岗，这本漫画把「猫是老板」的真相画得淋漓尽致，打工人看了直呼「太真实了」。",
    cover:
      "https://readdy.ai/api/search-image?query=A%20regal%20grey%20british%20shorthair%20cat%20sitting%20proudly%20on%20an%20office%20desk%20like%20a%20boss%2C%20warm%20cream%20and%20peach%20background%2C%20cute%20flat%20comic%20illustration%20cover%2C%20humorous%20office%20vibe&width=800&height=1000&seq=cover-grey-08&orientation=portrait",
    views: 73600,
    likes: 4980,
    collects: 2610,
    rating: 4.7,
    latestChapter: "第 78 话：查岗进行时",
    isHot: true,
    isNew: false,
    chapters: [
      { id: "c1", title: "第 78 话：查岗进行时", updateTime: "今天 07:50" },
      { id: "c2", title: "第 77 话：办公桌C位", updateTime: "昨天 16:00" },
      { id: "c3", title: "第 76 话：催饭大法", updateTime: "4 天前" },
    ],
  },
  {
    id: "kitten-growing",
    title: "小猫成长日记",
    category: "成长萌新",
    status: "连载中",
    tagline: "看着它一点点长大",
    author: "奶猫观察局",
    description:
      "从巴掌大的小奶猫，到能跳上冰箱顶的「大个子」，每一周的成长都值得记录。这本漫画用温暖的目光，记录小猫第一次睁眼、第一次吃猫粮、第一次用猫砂、第一次撒娇的珍贵瞬间。成长的每一天，都藏着满满的感动。",
    cover:
      "https://readdy.ai/api/search-image?query=A%20tiny%20baby%20kitten%20taking%20its%20first%20steps%20in%20a%20warm%20cozy%20home%2C%20soft%20cream%20and%20light%20coral%20background%2C%20cute%20flat%20comic%20illustration%20cover%2C%20tender%20and%20heartwarming%20mood&width=800&height=1000&seq=cover-kitten-09&orientation=portrait",
    views: 52100,
    likes: 3670,
    collects: 2750,
    rating: 4.8,
    latestChapter: "第 54 话：第一次跳高",
    isHot: false,
    isNew: true,
    chapters: [
      { id: "c1", title: "第 54 话：第一次跳高", updateTime: "今天 13:10" },
      { id: "c2", title: "第 53 话：学会用猫砂", updateTime: "昨天 18:00" },
    ],
  },
  {
    id: "cat-cafe-days",
    title: "猫咖打工日常",
    category: "生活日常",
    status: "连载中",
    tagline: "在猫咖上班是什么体验",
    author: "咖啡与猫",
    description:
      "毕业后我成了猫咖店员，从此过上了「每天被猫包围」的幸福生活。给客人上咖啡、给猫咪梳毛、处理猫咪抢零食的小插曲……这本漫画记录了一个普通人在猫咖的温馨日常，也画出了许多人向往的「与猫为伴」的理想生活。",
    cover:
      "https://readdy.ai/api/search-image?query=A%20cozy%20cat%20cafe%20interior%20with%20cats%20relaxing%20among%20coffee%20cups%20and%20warm%20lights%2C%20warm%20cream%20and%20amber%20background%2C%20cute%20flat%20comic%20illustration%20cover%2C%20relaxing%20cozy%20mood&width=800&height=1000&seq=cover-cafe-10&orientation=portrait",
    views: 42800,
    likes: 2890,
    collects: 1430,
    rating: 4.5,
    latestChapter: "第 43 话：抢零食风波",
    isHot: false,
    isNew: false,
    chapters: [
      { id: "c1", title: "第 43 话：抢零食风波", updateTime: "今天 09:40" },
      { id: "c2", title: "第 42 话：梳毛时间", updateTime: "昨天 20:30" },
    ],
  },
];

export function getComicById(id: string): Comic | undefined {
  return comics.find((c) => c.id === id);
}

export function getComicsByCategory(category: string): Comic[] {
  if (category === "all") return comics;
  return comics.filter((c) => c.category === category);
}

export const hotComics = comics.filter((c) => c.isHot);
export const newComics = comics.filter((c) => c.isNew);